import config from "config/appConfig";

import type { User } from "firebase/auth";

import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.FIREBASE_DATA}`;

export interface Values {
	user?: User;
}

export const initialState: IStateProps<Values> = {
	user: undefined
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
